import { render, staticRenderFns } from "./SectionResultatBareme.vue?vue&type=template&id=c126e772&scoped=true&"
import script from "./SectionResultatBareme.vue?vue&type=script&lang=js&"
export * from "./SectionResultatBareme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126e772",
  null
  
)

export default component.exports